import React, { Fragment } from "react";
import { PropTypes } from "prop-types";
import HtmlTooltip from "./HtmlTooltip";

export default function PriceTier({ type }) {
  return (
    <HtmlTooltip
      type={type}
      title={
        <Fragment>
          <p>
            <b>Price tiers for inventory items</b>
          </p>
          <p>
            This object is structured as follows:
            <pre>
              <code>
                {`
{
  "priceTier": {
    "id": integer,
    "name": string
  },
  "price": decimal,
  "quantity": decimal,
  "percentDiscount": decimal
}`}
              </code>
            </pre>
          </p>
        </Fragment>
      }
    ></HtmlTooltip>
  );
}
PriceTier.propTypes = {
  type: PropTypes.string.isRequired
};
